import { salesTransactionIsValid } from "services/sosInventoryService/salesTransaction/isValid";

export function isValid(record, relatedRecords, lines) {
  const errors = salesTransactionIsValid(record, relatedRecords, lines);
  return errors;
}
